module.exports = __webpack_public_path__ + "img/page.1ee41a1f.png";